import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from '../../../../components/common/utils/handleError.component';
import { PolizaEntity } from '../../entities/polizas_cliente_entity';
import { PolizaVAM, SiniestralidadClientes, ResumenSiniestralidad, SiniestralidadMaternidad, RankingDiagnosticos, ProveedoresSiniestralidad } from '../../entities/vam_entities';
import { SiniestralidadEmpresaServices } from './siniestralidad.service';

const swal = require("sweetalert2");

@Component({
    selector: 'siniestralidadEmpresa',
    templateUrl: 'siniestralidad.template.html',
    styleUrls: ["siniestralidad.style.css"]
})

export class SiniestralidadEmpresaComponent implements OnChanges {
    @Input() polizaContratada: PolizaEntity;
    polizaVam: PolizaVAM;
    nombresPlanes: string[];
    showLoader: string;
    showTab: boolean;

    es: any = {
        firstDayOfWeek: 1,
        dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
        dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
        monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", 'julio', "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
        monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
    };
    yearRange: string;
    maxDate: Date;
    minDate: Date;
    public resumen;

    public DetalleGrupo;
    public TitularesMayorValor;
    public TitularesMayorNumeroReclamos;
    public DetalleTitularesMayorValor;
    public TitularesDetalleMayorNumeroReclamos;
    public DetalleMayorNumeroReclamos;

    public DetalleSinMaternidad;
    public DiagnosticoPorReclamo;
    public DetalleProveedorXReclamo;
    public DetalleProveedorXValor;
    public top;

    constructor(private route: ActivatedRoute, private router: Router, private handleError: HandleError, private siniestralidadService: SiniestralidadEmpresaServices) {
        this.polizaVam = new PolizaVAM();
        this.polizaVam.TopRegistros = 10;
        this.polizaVam.TipoFecha = 1;
        let now = new Date(Date.now());
        let past = new Date(Date.now());
        past.setFullYear(past.getFullYear() - 10);
        this.yearRange = (now.getFullYear() - 10) + ":" + now.getFullYear();
        this.maxDate = now;
        this.minDate = past;
        this.DetalleGrupo = new SiniestralidadClientes();
        this.resumen = new ResumenSiniestralidad();
        this.TitularesMayorValor = [];
        this.DetalleTitularesMayorValor = [];
        this.DetalleMayorNumeroReclamos = [];
        this.showLoader = "";
        this.DetalleSinMaternidad = new SiniestralidadMaternidad();
        this.DiagnosticoPorReclamo = new RankingDiagnosticos();
        this.DetalleProveedorXReclamo = new ProveedoresSiniestralidad();
        this.DetalleProveedorXValor = new ProveedoresSiniestralidad();
        this.top = 10;
        this.showTab = false;
    }

    ngOnChanges() {
        this.polizaVam.Poliza = this.polizaContratada;
    }
    set dateFechaDesde(e) {
        this.polizaVam.FechaDesde = new Date(e);
    }

    get dateFechaDesde() {
        if (this.polizaVam.FechaDesde != undefined) {
            try {
                let a = this.polizaVam.FechaDesde.toISOString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                let a = this.polizaVam.FechaDesde.toString().substring(0, 10);
                let b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            }
        }
    }
    set dateFechaHasta(e) {
        this.polizaVam.FechaHasta = new Date(e);
    }

    get dateFechaHasta() {
        if (this.polizaVam.FechaHasta != undefined) {
            try {
                let a = this.polizaVam.FechaHasta.toISOString().substring(0, 10);
                let b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                let a = this.polizaVam.FechaHasta.toString().substring(0, 10);
                let b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            }
        }
    }

    ConsultarSiniestralidad(polizaVamEnviada: PolizaVAM) {
        this.showLoader = "sk-loading"
        this.showTab = false;
        polizaVamEnviada.Poliza.Opcion=1;

        this.siniestralidadService.consultaSiniestralidadVAMEmpresa(polizaVamEnviada).subscribe(
            result => {
                if (result.Clientes != null || result.DetalleDiagnostico != null || result.DiagnosticoXReclamo != null || result.Maternidad != null || result.ProveedorXReclamo != null || result.ProveedorXValor != null || result.RankingTitulares != null || result.Resumen != null) {
                    this.showTab = true;
                    this.resumen = result.Resumen;
                    this.DiagnosticoPorReclamo = result.DiagnosticoXReclamo;//aqui
                    this.DetalleSinMaternidad = result.Maternidad;//aqui
                    this.TitularesMayorValor = result.RankingTitulares.TitularesMayorValor;//aqui
                    this.TitularesMayorNumeroReclamos = result.RankingTitulares.TitularesMayorNumeroReclamos;//aqui
                    this.DetalleTitularesMayorValor = result.RankingTitulares.DetalleTitularesMayorValor;//aqui
                    this.DetalleMayorNumeroReclamos = result.RankingTitulares.DetalleTitularesMayorNumeroReclamos;
                    this.DetalleSinMaternidad = result.Maternidad;//aqui
                    this.DetalleProveedorXReclamo = result.ProveedorXReclamo;
                    this.DetalleProveedorXValor = result.ProveedorXValor;
                    this.top = polizaVamEnviada.TopRegistros;
                }else{
                    swal({
                        title: 'No existe información',
                        text: 'El reporte de siniestralidad no se encuentra disponible',
                        type: 'info'
                    })
                }
                this.showLoader = "";
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoader = "";
            }
        );
    }
    ExportarSiniestralidad(polizaVamEnviada: PolizaVAM) {
        this.showLoader = "sk-loading"
        this.showTab = false;
        polizaVamEnviada.Poliza.Opcion=1;
        this.siniestralidadService.exportarSiniestralidadVAMEmpresa(polizaVamEnviada).subscribe(
            result => {
                let a = document.createElement('a');
                document.body.appendChild(a);
                a.className = 'hidden';
                const fileBlob = result.blob();
                const blob = new Blob([fileBlob], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = polizaVamEnviada.Poliza.CodigoCliente + '-' + polizaVamEnviada.Poliza.CodigoPoliza + '-' + polizaVamEnviada.Poliza.CodigoRamo + '.xlsx';
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, polizaVamEnviada.Poliza.CodigoCliente + '-' + polizaVamEnviada.Poliza.CodigoPoliza + '-' + polizaVamEnviada.Poliza.CodigoRamo + '.xlsx');
                }
                else {
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
                this.showLoader = '';
                polizaVamEnviada.Poliza.Accion = 0;
                this.showLoader = "";
                this.showTab = false;
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoader = '';
            }
        );
    }


}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/siniestralidad/siniestralidad.component.ts